RivalIQ.apps.Alerts.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.MetricAlertPosts = Marionette.ItemView.mixin({
        ui: {
            view: '.x-view-metric-posts'
        },
        events: {
            'click @ui.view': 'onViewClick'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        childView: views.PostAlert,
        className: 'x-metric-posts',
        childViewContainer: '.x-event-posts',
        template: '#alertsMetricAlertPostsTemplate',

        onViewClick: function (e) {
            const me = this;

            e.preventDefault();

            const model = me.model;
            const metricModel = model.get('metric');

            const metric = metricModel.get('data');
            const source = metric.source;

            const companyId = encodeURIComponent(metricModel.get('company_id'));
            const company = me.options.companyData.get(companyId).toJSON();

            const eventTime = metricModel.get('event_time');
            const timePeriod = RivalIQ.utils.timePeriod.createTimePeriodFromDuration(7, eventTime);

            RivalIQ.apps.SocialPosts.views.PostsModal.show(me.dashboardModel.getProps(), source, company, timePeriod);
        }
    });

});
